<template>
    <v-card>
        <v-card-text>
            <div style="border: 2px dashed #373535 !important;border-radius: 0.5em;">
                <file-pond
                    name="audiofile"
                    ref="pond"
                    label-idle="Drop files here, or click to browse."
                    v-bind:allow-multiple="true"
                    accepted-file-types="audio/*"
                    :server="app.ajaxurl+'?action=dialer_upload_audio_file'"
                    v-bind:files="files"
                    v-on:init="handleFilePondInit"
                    v-on:processfiles="processFiles"
                    />
            </div>
            <!-- 
                for full page filepond dropzone
                :dropOnPage="true"
                :dropOnElement="false"
            -->

            <!-- BM: AUDIO FILES LIST -->
            <v-data-table
                :headers="headers"
                :items="user.audio_files"
                :items-per-page="5"
                class="elevation-1 mt-4"
                style="border:none;"
                :loading="user.audio_files_loading"
                loading-text="Loading..."
                :single-select="false"
                item-key="sid"
                :hide-default-footer="user.audio_files.length <= 5"
            >
                <template v-slot:item.filename="{ item }">
                    <a :href="item.url" target="_blank">{{item.filename}}</a>
                </template>
                <template v-slot:item.player="{ item }">
                    <audio-player :url="item.url" playerid="audio-player" :expanded="true"> </audio-player>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn icon @click="confirmDeleteAudioFile(item)"><v-icon>mdi-delete</v-icon></v-btn>
                </template>
            </v-data-table>
        </v-card-text>

        <!-- BM: CONFIRM DELETE AUDIO FILE -->
        <v-dialog
            width="60%"
            max-width="500"
            v-model="show_confirm_delete_dialog"
        >
            <v-card>
                <v-card-title class="text-h5">
                    Delete Audio File?
                </v-card-title>
                <v-card-text>
                    Are you sure you want to delete <strong>{{delete_file.filename}}</strong>?
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="show_confirm_delete_dialog = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        color="red"
                        @click="user.deleteAudioFile(delete_file); show_confirm_delete_dialog = false;"
                        :loading="user.audio_files_loading"
                        :disabled="user.audio_files_loading"
                    >
                        <v-icon>mdi-dlete</v-icon> Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </v-card>
</template>

<script>
// import Vue from 'vue'
import { useAppStore } from "../stores/app"
import { useUserStore } from '../stores/user'

import AudioPlayer from './AudioPlayer.vue'

// Import Vue FilePond
import vueFilePond from "vue-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
// import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

// import FilePondPluginImagePreview from "filepond-plugin-image-preview";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
//   FilePondPluginImagePreview
);

export default {
    name: 'AudioFiles',
    created: function() {
        this.app = useAppStore()
        this.user = useUserStore()
    },
    mounted: function() {
        this.user.fetchAudioFiles()
    },
    data: function () {
        return { 
            app: null,
            user: null,
            audio_file_url: null,
            files: null,
            show_confirm_delete_dialog: false,
            delete_file: {},
            headers: [    
                {
                    text: 'Audio Files',
                    align: 'start',
                    sortable: true,
                    value: 'filename',
                },
                {
                    text: '',
                    alert: 'start',
                    sortable: false,
                    value: 'player'
                },
                {
                    text: '',
                    value: 'actions',
                    align: 'center',
                    sortable: false
                }
            ],
         };

    },
    methods: {
        handleFilePondInit: function () {
            // FilePond instance methods are available on `this.$refs.pond`
        },
        processFiles: function() {
            this.user.fetchAudioFiles()
            this.files = null
        },
        confirmDeleteAudioFile: function(file) {
            this.delete_file = file
            this.show_confirm_delete_dialog = true
        }
    },
    components: {
        FilePond,
        AudioPlayer
    }
}
</script>

<style>

.filepond--credits {
    display: none !important;
}

.filepond--drop-label {
    /* background-color: #1e1e1e; */
    background-color: transparent !important;
}

/* the text color of the drop label*/
.filepond--drop-label > label {
    color: #ccc;
}

/* use a hand cursor intead of arrow for the action buttons */
.filepond--file-action-button {
    cursor: pointer;
}

/* underline color for "Browse" button */
.filepond--label-action {
    text-decoration-color: #aaa;
}

/* the border radius of the drop area */
.filepond--panel-root {
    border-radius: 0.5em;
}

/* the border radius of the file item */
.filepond--item-panel {
    border-radius: 0.5em;
}


/* bordered drop area */
/* the background color of the filepond drop area */
.filepond--panel-root {
    background-color: transparent !important;
    border: none !important;
}

.filepond--item-panel {
    background-color: #555;
}
</style>